import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { User, Log } from 'oidc-client-ts';
import { AuthProvider } from 'react-oidc-context';

import {
  configStore,
  AppContainer,
  userManager,
  handleNewOrRefreshedToken,
  redirectToLogin
} from '../internal'

export const store = configStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <AuthProvider
          userManager={userManager}
          onSigninCallback={async (user?: User) => {
            if (user) {
              await handleNewOrRefreshedToken(user);
            }
          }}
          onSignoutCallback={(...d) => { return; }}
          onRemoveUser={(...d) => {
            // react-oidc-context invokes this ONLY from its own auth.removeUser()
            // wrapper (e.g. the explicit logout in OidcLogoutContainer), never
            // from the raw userManager.removeUser() our teardown uses — so this
            // safely drives the post-logout redirect to the OIDC page.
            store?.dispatch(redirectToLogin());
          }} >
            <AppContainer />
        </AuthProvider>
      </Provider>
    )
  }
}